let popUpElements = {
    modal: document.querySelector('.popup'),
    closeButton: document.querySelector('.popup__close'),
  };
  
  const removePopUp = () => {
    let { modal } = popUpElements;
    modal.classList.add('popup--hidden');
    localStorage.setItem('popUpSeen', true);
  };
  
  const popUpWatchEvents = () => {
    let { closeButton } = popUpElements;
    closeButton.addEventListener('click', () => removePopUp());
  }
  
  const openPopUp = () => {
    let { modal } = popUpElements;
    modal.classList.remove('popup--hidden');
    popUpWatchEvents();
  }
  
  function PopUp () {
  
    // Open up after three seconds (3000 milliseconds).
    window.onload = ()  => setTimeout(() => openPopUp(), 3000);
  
  }
  
  export default PopUp;